<template>
    <div>
        <div class="form-row mb-3">
            <div class="col-sm-3">
                <label class="sr-only" for="filter_category">Categoría</label>
                <input class="form-control" id="filter_category" placeholder="Categoría" type="text"
                       v-model="filters.category" @keyup.enter="search">
            </div>
            <div class="col-sm-3">
                <label class="sr-only" for="filter_subcategory">Subcategoría</label>
                <input class="form-control" id="filter_subcategory" placeholder="Subcategoría" type="text"
                       v-model="filters.subcategory" @keyup.enter="search">
            </div>
            <div class="col-sm-3">
                <label class="sr-only" for="filter_keyword">Keyword</label>
                <input class="form-control" id="filter_keyword" placeholder="Keyword" type="text"
                       v-model="filters.keyword" @keyup.enter="search">
            </div>
            <div class="col-sm-3">
                <button class="btn btn-primary mr-2" type="button" @click="search">
                    <font-awesome-icon :icon="['fas', 'search']"/>
                    Buscar
                </button>
                <button class="btn btn-secondary" type="button" @click="clearFilters">
                    Limpiar
                </button>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table table-bordered table-hover">
                <thead>
                <tr>
                    <th style="width: 90px;">ID</th>
                    <th>Categoría</th>
                    <th>Subcategoría</th>
                    <th>Pregunta</th>
                    <th>Respuesta</th>
                    <th>Keywords</th>
                    <th style="width: 70px;">Acciones</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="loading">
                    <td class="text-center" colspan="7">
                        <img alt="loading" height="40px" src="/images/loading.svg"/>
                    </td>
                </tr>
                <tr v-else-if="faqs.length === 0">
                    <td class="text-center" colspan="7">Sin resultados</td>
                </tr>
                <tr :key="faq.id" v-else v-for="faq in faqs">
                    <td>
                        <h5>
                            <router-link :to="{ name: 'FaqsEmbeddingEdit', params: { id: faq.id } }">
                                <span class="badge badge-secondary" style="text-decoration: underline;color: #BD0D12">{{ faq.id }}</span>
                            </router-link>
                        </h5>
                    </td>
                    <td>{{ faq.category }}</td>
                    <td>{{ faq.subcategory }}</td>
                    <td>{{ faq.question }}</td>
                    <td class="text-truncate" style="max-width: 240px;">{{ faq.answer }}</td>
                    <td>
                        <div class="float-left">
                            <span v-for="key in  faq.keywords" class="badge badge-pill badge-light mr-1">
                                {{key}}
                            </span>
                        </div>
                    </td>
                    <td>
                        <menu-edit :id="faq.id" :name="faq.question" :options="menuOptions"
                                   @remove="remove(faq.id)"/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="d-flex justify-content-between align-items-center">
            <div>
                Total: {{ pagination.total }} - Página {{ pagination.page }} de {{ pagination.pages || 1 }}
            </div>
            <div class="d-flex align-items-center">
                <label class="sr-only" for="filter_limit">Resultados por página</label>
                <select class="form-control mr-2" id="filter_limit" style="width: auto;" v-model.number="filters.limit" @change="search">
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
                <button :disabled="pagination.page <= 1 || loading" class="btn btn-outline-danger mr-2"
                        type="button" @click="goToPage(pagination.page - 1)">
                    <i class="fa fa-fw fa-chevron-left"></i>
                </button>
                <button :disabled="pagination.page >= pagination.pages || loading" class="btn btn-outline-danger"
                        type="button" @click="goToPage(pagination.page + 1)">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { API } from './../../api'
    import MenuEdit from './../../components/MenuEdit'

    export default {
        components: {
            'menu-edit': MenuEdit
        },
        data: () => {
            return {
                loading: false,
                faqs: [],
                filters: {
                    page: 1,
                    limit: 20,
                    category: '',
                    subcategory: '',
                    keyword: ''
                },
                pagination: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    pages: 1
                }
            }
        },
        computed: {
            menuOptions: function () {
                let options = []
                if (this.$can('update', 'frequentquestions')) {
                    options.push({
                        type: 'edit',
                        text: '',
                        link: 'faqs_embedding/edit/',
                        icon: 'dot-circle',
                        callback: '',
                        type_action: 'link'
                    })
                }
                if (this.$can('delete', 'frequentquestions')) {
                    options.push({
                        type: 'delete',
                        text: '',
                        link: '',
                        icon: 'trash',
                        type_action: 'button',
                        callback_delete: 'remove'
                    })
                }
                return options
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            search () {
                this.filters.page = 1
                this.fetchData()
            },
            clearFilters () {
                this.filters.category = ''
                this.filters.subcategory = ''
                this.filters.keyword = ''
                this.filters.page = 1
                this.fetchData()
            },
            goToPage (page) {
                if (page < 1 || (this.pagination.pages && page > this.pagination.pages)) {
                    return
                }
                this.filters.page = page
                this.fetchData()
            },
            fetchData () {
                this.loading = true
                let params = {}
                Object.keys(this.filters).forEach((key) => {
                    if (this.filters[key] !== '' && this.filters[key] !== null && this.filters[key] !== undefined) {
                        params[key] = this.filters[key]
                    }
                })
                API.get('faqs_embedding', { params: params }).then((result) => {
                    this.loading = false
                    this.faqs = result.data.data
                    this.pagination = result.data.pagination
                }).catch((error) => {
                    this.loading = false
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'FAQs (IA)',
                        text: (error.response && error.response.data && error.response.data.error)
                            ? error.response.data.error.message
                            : this.$t('inclusions.error.messages.connection_error')
                    })
                })
            },
            remove (id) {
                API({
                    method: 'DELETE',
                    url: 'faqs_embedding/' + id
                }).then(() => {
                    this.fetchData()
                    this.$notify({
                        group: 'main',
                        type: 'success',
                        title: 'FAQs (IA)',
                        text: 'FAQ eliminada correctamente'
                    })
                }).catch((error) => {
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'FAQs (IA)',
                        text: (error.response && error.response.data && error.response.data.error)
                            ? error.response.data.error.message
                            : this.$t('inclusions.error.messages.connection_error')
                    })
                })
            }
        }
    }
</script>

<style lang="stylus">
</style>
